import {
  useGetEconomicSectors,
  useGetGenders,
  useGetProductTransactionCodes,
  useGetProductOwnerships,
  useGetProductCategories,
  useGetMerchantSegments,
} from "../../../hooks/queries/useMerchantQueries";

export const useMerchantReferenceData = (enabled = true) => {
  const {
    data: economicSectors = [],
    isLoading: economicSectorsLoading,
    isError: isEconomicSectorsError,
  } = useGetEconomicSectors(enabled);

  const {
    data: genders = [],
    isLoading: gendersLoading,
    isError: isGendersError,
  } = useGetGenders(enabled);

  const {
    data: productTransactionCodes = [],
    isLoading: productTransactionCodesLoading,
    isError: isProductTransactionCodesError,
  } = useGetProductTransactionCodes(enabled);

  const {
    data: productOwnerships = [],
    isLoading: productOwnershipsLoading,
    isError: isProductOwnershipsError,
  } = useGetProductOwnerships(enabled);

  const {
    data: productCategories = [],
    isLoading: productCategoriesLoading,
    isError: isProductCategoriesError,
  } = useGetProductCategories(enabled);

  const {
    data: merchantSegments = [],
    isLoading: merchantSegmentsLoading,
    isError: isMerchantSegmentsError,
  } = useGetMerchantSegments(enabled);

  return {
    referenceData: {
      economicSectors,
      genders,
      productTransactionCodes,
      productOwnerships,
      productCategories,
      merchantSegments,
    },

    loadingStates: {
      economicSectorsLoading,
      gendersLoading,
      productTransactionCodesLoading,
      productOwnershipsLoading,
      productCategoriesLoading,
      merchantSegmentsLoading,
    },

    errorStates: {
      economicSectorsError: isEconomicSectorsError,
      gendersError: isGendersError,
      productTransactionCodesError: isProductTransactionCodesError,
      productOwnershipsError: isProductOwnershipsError,
      productCategoriesError: isProductCategoriesError,
      merchantSegmentsError: isMerchantSegmentsError,
    },
  };
};

export default useMerchantReferenceData;
